function ClearButton({ inputid, clickHandler }) {
  return (
    <div className="clear-button" inputid={inputid} onClick={clickHandler}>&times;</div>
  )
}

export default ClearButton